module.exports = __webpack_public_path__ + "static/28-3e57417faa4197704b06f99b7d572731.png";